import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatSort, Sort} from '@angular/material/sort';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {FormControl} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {TableControl} from '../../../../../common/models/TableControl';
import {DateUtil} from '../../../../../common/util/DateUtil';
import {PagedRequestDTO} from '../../../../../common/models/PagedRequestDTO';
import {DisplayIcon} from 'src/app/modules/common/components';
import {
  ConfirmationDialogComponent
} from '../../../../../common/dialogs/confirmation-dialog/confirmation-dialog.component';
import {DrugManagementPlanDTO} from '../../../../models/DrugManagementPlanDTO';
import {DrugManagementPlanService} from '../../../../services/drug-management-plan.service';
import {detailsExpand} from '../../../../../common';
import {createFieldMap, getSortDirection} from '../../../../../common/util/Util';
import {SharedService} from '../../../../../common/services/shared-service';
import {EntityTable} from '../../../../../common/types/entity-table.enum';

@Component({
  selector: 'app-drug-management-plans',
  templateUrl: './drug-management-plans.component.html',
  styleUrls: [
    '../../../../../../../styles/global/_management-styles.scss'
  ],
  animations: [detailsExpand]
})
export class DrugManagementPlansComponent implements OnInit {
  readonly DisplayIcon = DisplayIcon;

  drugManagementPlanFormControl: FormControl;
  drugManagementPlanTableControl: TableControl;
  drugManagementPlanDisplayedColumns: string[] = [
    'icons',
    'drugManagementPlanId',
    'name',
    'policy',
    'product',
    'startDate',
    'endDate'
  ];
  drugManagementPlanExpandedRow: DrugManagementPlanDTO | null;
  drugManagementPlanDataSource: DrugManagementPlanDTO[];

  isConfirmed = false;
  dateFormat = DateUtil.dateFormat;
  dateTimeFormat = DateUtil.dateTimeFormat;
  length = 100;
  pageSize = 10;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  @ViewChild('matSort', {static: false}) tableSort: MatSort;
  @ViewChild('drugManagementPlanSort', {static: false}) drugManagementPlanSort: MatSort;
  @ViewChild('drugManagementPlanPaginator', {static: false}) drugManagementPlanPaginator: MatPaginator;
  @ViewChild('drugManagementPlanSearch') private drugManagementPlanSearch: ElementRef;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private sharedService: SharedService,
    private drugManagementPlanService: DrugManagementPlanService,
  ) {
    this.drugManagementPlanFormControl = new FormControl('');


    this.drugManagementPlanTableControl = new TableControl(
      this.length,
      this.pageSize,
      this.pageNumber,
      this.pageSizeOptions,
      'drugManagementPlanId',
      'desc',
      'name',
      ''
    );
  }

  ngOnInit(): void {
    this.getListOfDrugManagementPlans(this.drugManagementPlanTableControl);
  }

  getListOfDrugManagementPlans(tableControl: TableControl): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblDrugManagementPlan;
    pagedRequestDTO.pageNumber = tableControl.pageNumber;
    pagedRequestDTO.pageSize = tableControl.pageSize;
    pagedRequestDTO.sortField = tableControl.sortField;
    pagedRequestDTO.sortDirection = getSortDirection(
      tableControl.sortDirection
    );
    pagedRequestDTO.fieldMap = createFieldMap(
      tableControl.filterField,
      tableControl.filterValue
    );

    this.drugManagementPlanService.getListOfDrugManagementPlans(pagedRequestDTO).subscribe(
      (response) => {
        this.drugManagementPlanDataSource = response.resultList;
        this.drugManagementPlanTableControl.length = response.totalRecords;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  pageChanged($event: PageEvent) {
    this.drugManagementPlanTableControl.pageNumber = $event.pageIndex;
    this.drugManagementPlanTableControl.pageSize = $event.pageSize;
    this.getListOfDrugManagementPlans(this.drugManagementPlanTableControl);

  }

  sortData($event: Sort) {
    if (this.drugManagementPlanPaginator != null) {
      this.drugManagementPlanPaginator.firstPage();
    }
    this.drugManagementPlanTableControl.pageNumber = 0;
    this.drugManagementPlanTableControl.sortField = $event.active;
    this.drugManagementPlanTableControl.sortDirection = $event.direction;
    this.getListOfDrugManagementPlans(this.drugManagementPlanTableControl);
  }

  onKeyUpFilterData(filterField: string) {
    if (this.drugManagementPlanPaginator != null) {
      this.drugManagementPlanPaginator.firstPage();
    }
    this.drugManagementPlanTableControl.pageNumber = 0;
    this.drugManagementPlanTableControl.filterField = filterField;
    this.drugManagementPlanTableControl.filterValue = this.drugManagementPlanFormControl.value;
    this.getListOfDrugManagementPlans(this.drugManagementPlanTableControl);
  }

  deleteEntry(event: MouseEvent, id: number) {
    event.preventDefault();
    event.stopPropagation();

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '40vw',
      data: 'Are you sure you wish to delete this entity?'
    });

    dialogRef.afterClosed().subscribe((result) => {
      const isConfirmed = result;

      if (isConfirmed) {
        this.drugManagementPlanService.deleteDrugManagementPlan(id).subscribe(
          () => {
            this.sharedService.openSnackBar(`Drug Management Plan ${id} deleted`, 'Dismiss');
            this.getListOfDrugManagementPlans(this.drugManagementPlanTableControl);
          },
          (errorResponse) => {
            const error = errorResponse.error;
            this.sharedService.openErrorDialog(error.businessMessage);
          }
        );
      }
    });
  }

  editEntry(event: MouseEvent, id: number) {
    event.preventDefault();
    event.stopPropagation();

    this.router.navigate(['/pharmacy-management/edit-drug-management-plan/' + id]);
  }

  displayObjectNameIfNotNull(obj: any) {
    return obj == null ? '' : obj.name;
  }

  endDateDisplay(testDate: Date): Date {
    const openDate = new Date('2999-12-31');
    // eslint-disable-next-line eqeqeq
    // @ts-ignore
    return openDate.setHours(0, 0, 0) == testDate ? null : testDate;
  }
}
